import React, { useState } from "react"
import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"
import { withTranslation } from "gatsby-plugin-react-i18next"
import { graphql, useStaticQuery } from "gatsby"
import ProductList from "./ProductList"
// import Hero from "./Hero"
import MobileFilters from "./MobileFilters"
import DesktopFilters from "./DesktopFilters"
import MobileNavigation from "./MobileNavigation"
import DesktopNavigation from "./DesktopNavigation"
import { getFilteredProducts } from "../../services/filterHelperV2"
import YellowGold from "../../resources/img/ui/swatches/yellow-gold-engagement.svg"
import RoseGold from "../../resources/img/ui/swatches/rose-gold-engagement.svg"
import WhiteGold from "../../resources/img/ui/swatches/white-gold-engagement.svg"
import Platinum from "../../resources/img/ui/swatches/platinum-engagement.svg"
import CollectionDescription from "./CollectionDescription"
import { replaceMaterialWord } from "../../services/material"
import { getStartingPrice } from "../../services/engagementRingHelper"
import Intro from "./Intro"
import { getProductCardContent } from "../../services/productHelper"

const Grid = styled.div`
  max-width: 1440px;
  margin: 0 auto 78px;
  @media (min-width: ${breakpoints.lg}) {
    display: grid;
    grid-template-columns: 281px 1fr;
    margin-bottom: 156px;
  }
  @media (min-width: ${breakpoints.max}) {
    max-width: ${breakpoints.max};
  }
`

const PageContents = styled.div`
  /* max-width: 1180px; */
  margin: auto;
  @media (min-width: ${breakpoints.lg}) {
    padding-right: 46px;
  }
`

const LayeredNavigation = ({
  category,
  products,
  t,
  material,
  productContents,
}) => {
  const data = useStaticQuery(graphql`
    query {
      engagementRings: allContentfulEngagementRing(
        sort: { order: ASC }
        filter: { staging: { ne: true } }
      ) {
        nodes {
          ...EngagementRingCardFragment
        }
      }
      materials: allShopifyProduct(
        filter: { productType: { in: ["Band", "Diamond"] } }
      ) {
        nodes {
          ...MaterialFragment
        }
      }
      bespokeService: file(relativePath: { eq: "plp/bespoke.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 1390)
        }
      }
      weddingBands: file(relativePath: { eq: "plp/wedding-band-focus.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 1390)
        }
      }
      weddingHim: file(relativePath: { eq: "plp/wedding-him.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 1390)
        }
      }
      weddingHer: file(relativePath: { eq: "plp/wedding-her.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 1390)
        }
      }
      weddingBespoke: file(relativePath: { eq: "plp/wedding-bespoke.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 1390)
        }
      }
    }
  `)

  const { title, showStagingProduct, handle, isEngagement, h1 } = category

  const isEngagementPlp = handle === "engagement-rings"
  const isWeddingBandPLP =
    handle === "wedding-bands-for-her" || handle === "wedding-bands-for-him"

  let gender

  if (isWeddingBandPLP) {
    gender = handle === "wedding-bands-for-her" ? "f" : "m"
  }

  const {
    bespokeService,
    weddingBands,
    weddingHim,
    weddingHer,
    weddingBespoke,
  } = data

  const engagementRings = data.engagementRings.nodes
  const materials = data.materials.nodes

  const diamonds = materials.filter(
    (product) => product.productType === "Diamond"
  )
  const bands = materials.filter((product) => product.productType === "Band")

  const engagementMaterials = { diamonds, bands }

  const langTag = process.env.LANG_TAG
  const isFrance = langTag === "fr-FR"

  const localisedEngagementRings = engagementRings.filter((ring) => {
    if (isFrance) {
      return ring.node_locale === "fr"
    } else {
      return ring.node_locale !== "fr"
    }
  })

  const filterOptions = [
    {
      title: t("plp.filter.sort_by"),
      value: "sort",
      options: [
        { title: t("plp.filter.sort_all"), value: "all" },
        { title: t("plp.filter.sort_newest"), value: "newest" },
        { title: t("plp.filter.sort_lowest"), value: "lowest" },
        { title: t("plp.filter.sort_highest"), value: "highest" },
      ],
    },
    {
      title: t("plp.filter.gold_colour"),
      value: "colour",
      options: [
        {
          title: t("plp.filter.sort_yellow_gold"),
          value: "yellow gold",
          icon: YellowGold,
          order: 0,
        },
        {
          title: t("plp.filter.sort_rose_gold"),
          value: "rose gold",
          icon: RoseGold,
          order: 1,
        },
        {
          title: t("plp.filter.sort_white_gold"),
          value: "white gold",
          icon: WhiteGold,
          order: 2,
        },
        isEngagementPlp
          ? {
              title: t("plp.filter.sort_platinum"),
              value: "platinum",
              icon: Platinum,
              order: 3,
            }
          : null,
      ],
    },
    !isEngagementPlp && !isWeddingBandPLP
      ? {
          title: t("plp.filter.price"),
          value: "price",
          options: [
            { title: t("plp.filter.sort_under_300"), value: 300 },
            { title: t("plp.filter.sort_under_500"), value: 500 },
            { title: t("plp.filter.sort_under_750"), value: 750 },
            { title: t("plp.filter.sort_under_1000"), value: 1000 },
          ],
        }
      : null,
    isEngagementPlp
      ? {
          title: t("plp.filter.style"),
          value: "style",
          options: [
            { title: t("plp.filter.sort_classic"), value: "classic" },
            { title: t("plp.filter.sort_edgy"), value: "edgy" },
            { title: t("plp.filter.sort_modern"), value: "modern" },
            { title: t("plp.filter.sort_statement"), value: "statement" },
          ],
        }
      : null,
    isWeddingBandPLP
      ? {
          title: t("plp.filter.style"),
          value: "style",
          options: [
            { title: t("plp.filter.sort_classic"), value: "classic" },
            { title: t("plp.filter.sort_eternity"), value: "eternity" },
            { title: t("plp.filter.sort_bezel"), value: "bezel" },
            { title: t("plp.filter.sort_statement"), value: "statement" },
          ],
        }
      : null,
    {
      title: t("plp.filter.type"),
      value: "type",
      options: isEngagementPlp
        ? [
            { title: t("plp.filter.sort_solitaire"), value: "solitaire" },
            { title: t("plp.filter.sort_pave"), value: "pave" },
            { title: t("plp.filter.sort_trilogy"), value: "trilogy" },
            {
              title: t("plp.filter.sort_floating_diamond"),
              value: "floating-diamond",
            },
          ]
        : isWeddingBandPLP
          ? [
              { title: t("plp.filter.sort_plain"), value: "plain" },
              { title: t("plp.filter.sort_pave"), value: "pave" },
              { title: t("plp.filter.sort_comfort"), value: "comfort" },
              { title: t("plp.filter.sort_curved"), value: "curved" },
            ]
          : [
              { title: t("plp.filter.sort_solitaire"), value: "solitaire" },
              { title: t("plp.filter.sort_engravable"), value: "engraving" },
              { title: t("plp.filter.sort_statement"), value: "statement" },
              { title: t("plp.filter.for_him"), value: "for-him" },
            ],
    },
  ]

  const getDefaultColourOption = () => {
    let colours = []
    if (material) {
      let colourOptions = filterOptions.find(
        (option) => option.value === "colour"
      )

      if (colourOptions) {
        const optionValues = colourOptions.options

        let selectedDefaultValue = optionValues?.find(
          (value) => value?.value === material.value
        )

        if (selectedDefaultValue) {
          colours = [selectedDefaultValue]
        }
      }
    }

    return colours
  }

  const [filters, setFilters] = useState({
    colours: getDefaultColourOption(),
    price: null,
    sort: { title: "All", value: "all" },
    types: [],
    styles: [],
  })

  const [sort, setSort] = useState(filters.sort)
  const [colours, setColours] = useState(filters.colours)
  const [price, setPrice] = useState(filters.price)
  const [types, setTypes] = useState(filters.types)
  const [styles, setStyles] = useState(filters.styles)

  const handleTypeFilter = (option) => {
    if (types) {
      const selectedTypes = [...types]
      const selectedTypeValues = selectedTypes.map((type) => type.value)
      let newSelectedTypes = []

      if (selectedTypeValues.includes(option.value)) {
        const newSelects = selectedTypes.filter(
          (type) => type.value !== option.value
        )
        newSelectedTypes = [...newSelects]
      } else {
        newSelectedTypes = [...selectedTypes, option]
      }
      setTypes(newSelectedTypes)
    } else {
      setTypes([option])
    }
  }

  const handleStyle = (option) => {
    if (styles) {
      const selectedStyles = [...styles]
      const selectedStyleValues = selectedStyles.map((style) => style.value)
      let newSelectedStyles = []

      if (selectedStyleValues.includes(option.value)) {
        const newSelects = selectedStyles.filter(
          (style) => style.value !== option.value
        )
        newSelectedStyles = [...newSelects]
      } else {
        newSelectedStyles = [...selectedStyles, option]
      }
      setStyles(newSelectedStyles)
    } else {
      setStyles([option])
    }
  }

  const handlePrice = (option) => {
    if (price) {
      if (price.value === option.value) {
        setPrice(null)
      } else {
        setPrice(option)
      }
    } else {
      setPrice(option)
    }
  }

  const handleColour = (option) => {
    if (colours) {
      const selectedColours = [...colours]
      const selectedColourValues = selectedColours.map((colour) => colour.value)
      let newSelectedColours = []

      if (selectedColourValues.includes(option.value)) {
        const newSelects = selectedColours.filter(
          (colour) => colour.value !== option.value
        )
        newSelectedColours = [...newSelects]
      } else {
        newSelectedColours = [...selectedColours, option]
      }
      setColours(newSelectedColours.sort((a, b) => a.order - b.order))
    } else {
      setColours([option])
    }
  }

  const applyFilter = () => {
    const newFilter = {
      colours: [...colours],
      sort,
      price,
      types: [...types],
      styles: [...styles],
    }

    setFilters(newFilter)
  }

  const clearFilter = (size) => {
    if (!size) {
      setSort({ title: "All", value: "all" })
    }
    setColours([])
    setPrice(null)
    setTypes([])
    setStyles([])

    // const newFilter = {
    //   colours: [],
    //   sort: { title: "All", value: "all" },
    //   price: null,
    //   types: [],
    // }

    // setFilters(newFilter)
  }

  const jewelryProducts = products
    .map((product) => getProductCardContent(product, productContents))
    .filter((product) => {
      const categoryHandle = category.handle

      if (categoryHandle === "winter-archives") {
        return true
      }

      if (product.tags.includes("winter-archives")) {
        return false
      }

      return true
    })
    .filter((product) => {
      if (
        (product.productType === "Band" || product.productType === "Diamond") &&
        product.handle !== "oprah-eternity-band" &&
        category.urlKey !== "wedding-rings-bands"
      ) {
        // Special exception for oprah ring due to product image
        return false
      }

      return showStagingProduct ? true : !product.tags.includes("staging")
    })

  let filteredProducts = [
    ...jewelryProducts,
    ...localisedEngagementRings
      .map((ring) => {
        ring.startingPrice = getStartingPrice(ring, diamonds, bands)
        ring.product_type = "engagement_ring"
        return ring
      })
      .filter(() => isEngagementPlp),
  ]

  filteredProducts = getFilteredProducts(filteredProducts, filters)

  let descriptionTitle
  let goldDescription

  let materialColor

  if (material) {
    materialColor = material.color
  }

  if (category) {
    descriptionTitle = category.descriptionTitle
      ? category.descriptionTitle
      : `${category.title} / ${t("navigation.plp.description_title.default")}`

    goldDescription = category.description

    if (material) {
      descriptionTitle = replaceMaterialWord(descriptionTitle, materialColor)
    }
  }

  const h1ByMaterial = h1 && replaceMaterialWord(h1, materialColor)
  const heroTitle = title && replaceMaterialWord(title, materialColor)
  const shortDescription =
    category.shortDescription?.shortDescription &&
    replaceMaterialWord(
      category.shortDescription?.shortDescription,
      materialColor
    )

  return (
    <div>
      <Grid>
        <div>
          <DesktopNavigation engagement={isEngagement} />
        </div>
        <div>
          <MobileFilters
            filterOptions={filterOptions}
            applyFilter={applyFilter}
            setSort={setSort}
            handleColour={handleColour}
            handlePrice={handlePrice}
            handleTypeFilter={handleTypeFilter}
            handleStyle={handleStyle}
            colours={colours}
            types={types}
            price={price}
            styles={styles}
            sort={sort}
            clearFilter={clearFilter}
          />
          <MobileNavigation
            wedding={isWeddingBandPLP}
            engagement={isEngagementPlp}
          />
          <Intro
            collectionName={heroTitle}
            pageTitle={h1ByMaterial}
            shortDescription={shortDescription}
          />
          <DesktopFilters
            filterOptions={filterOptions}
            applyFilter={applyFilter}
            setSort={setSort}
            handleColour={handleColour}
            handlePrice={handlePrice}
            handleTypeFilter={handleTypeFilter}
            handleStyle={handleStyle}
            colours={colours}
            types={types}
            price={price}
            sort={sort}
            styles={styles}
            clearFilter={clearFilter}
            wedding={isWeddingBandPLP}
          />
          <PageContents>
            <ProductList
              products={filteredProducts}
              colours={filters.colours}
              engagementMaterials={engagementMaterials}
              engagement={isEngagementPlp}
              weddingBands={weddingBands}
              bespokeService={bespokeService}
              wedding={isWeddingBandPLP}
              gender={gender}
              weddingBespoke={weddingBespoke}
              weddingHim={weddingHim}
              weddingHer={weddingHer}
            />
          </PageContents>
        </div>
      </Grid>
      {isWeddingBandPLP ? null : (
        <CollectionDescription
          title={descriptionTitle}
          description={goldDescription}
          materialColor={materialColor}
        />
      )}
    </div>
  )
}

export default withTranslation()(LayeredNavigation)
